<section>
  <div class="container mx-auto flex items-center justify-center min-h-screen">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="max-w-xl w-full">
      <app-input
        formControlName="identifier"
        label="Adresse email or phone"
        type="text"
        placeholder="Entrez votre email or phone"
        [error]="getErrorMessage('identifier')"
      ></app-input>
      <!-- [error]="f.identifier.touched && f.identifier.invalid ? 'Email invalide' : null" -->

      <app-password-input
        formControlName="password"
        label="Mot de passe"
        type="password"
        placeholder="Entrez votre mot de passe"
        [error]="getErrorMessage('password')"
      ></app-password-input>
      <!-- [error]="f.password.touched && f.password.invalid ? 'Min 6 caractères' : null" -->

      <button type="submit">Envoyer</button>
    </form>
  </div>
</section>
